import { Injectable } from '@angular/core';
import { HttpService } from '@core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DemoClientService {
  constructor(private httpService: HttpService) {}

  public checkDemoClient(clientId: string): Observable<boolean> {
    const url = `/MockAPIResponse/GetIsDemoUser?ClientId=${clientId}&subscription-key=${environment.scApiSubscriptionKey}`;
    return this.httpService.get<boolean>(url);
  }

  public set updateDemoClientFlag(demoClient: boolean) {
    localStorage.setItem('IsDemoClient', JSON.stringify(demoClient));
  }

  public get getDemoClientFlag(): boolean {
    return JSON.parse(localStorage.getItem('IsDemoClient'));
  }
}
